// extracted by mini-css-extract-plugin
export var infoSection = "_x-1";
export var infoSectionContainer = "_x-0";
export var infoSectionTitleRow = "_x-2";
export var multiLineInfo = "_x-4";
export var strong = "_x-3";